/* eslint-disable max-lines */
import { exportUsers } from 'actions';
import Permissions from 'components/Permissions';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCustomerName } from 'selectors/auth';
import { useSelector } from 'store';
import ManageCohortsModal from './ManageCohortsModal';

const MonitoredUsersHeaderButtons: React.FC = () => {
  const dispatch = useDispatch();

  const customerName = useSelector(getCustomerName);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleExportUsers = (): void => {
    dispatch(exportUsers({ filename: `${customerName}_MonitoredUsers`, export_type: 'monitored' }));
  };

  const toggleModalOpen = (): void => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <div className="flex flex-row justify-start gap-2">
        <button
          onClick={handleExportUsers}
          type="button"
          className="h-8 button button--secondary focus:outline-none"
          key="export"
        >
          <span className="font-bold whitespace-no-wrap">Download CSV</span>
        </button>

        <Permissions action="customers.list">
          <button
            type="button"
            className="w-36 h-8 flex flex-row justify-center button button--primary focus:outline-none whitespace-no-wrap"
            key="add"
            onClick={(): void => {
              toggleModalOpen();
            }}
          >
            Manage Cohort
          </button>
        </Permissions>
      </div>
      {isModalOpen && (
        <ManageCohortsModal isModalOpen={isModalOpen} toggleModalOpen={toggleModalOpen} />
      )}
    </>
  );
};

export default MonitoredUsersHeaderButtons;
